import {CircularProgress} from "@mui/material";
import Utils from "@/components/Shared/Utils";

export default function AsyncButton({disabled, isLoading, callback, text}: {
    disabled?: boolean,
    isLoading?: boolean,
    callback?: any,
    text: string
}) {
    return (
        <Utils.FormUtils.PrimaryButton
            startIcon={isLoading && <CircularProgress size={20} sx={{color: 'white'}}/>}
            disabled={disabled}
            onClick={() => callback()}>
            {text}
        </Utils.FormUtils.PrimaryButton>
    )
}